import { useFadeIn } from '@/hooks/useFadeIn';

const reasons = [
  {
    num: '01',
    icon: 'ri-scissors-cut-line',
    title: '削らない・傷つけない',
    desc: '歯の表面を削る処置は一切ありません。健康な歯質を守りながら、白斑だけを自然に改善します。',
  },
  {
    num: '02',
    icon: 'ri-syringe-line',
    title: '麻酔不要・痛みなし',
    desc: '注射を使わずに受けられます。ジェルが歯茎に触れる軽いしみる感覚はありますが、ほぼ痛みはありません。',
  },
  {
    num: '03',
    icon: 'ri-time-line',
    title: '1回の通院で完結',
    desc: '所要時間は約30〜60分。当日から食事も通常通りOK。特別な制限はありません。',
  },
];

interface ReasonCardProps {
  num: string;
  icon: string;
  title: string;
  desc: string;
  delay: number;
}

function ReasonCard({ num, icon, title, desc, delay }: ReasonCardProps) {
  const fade = useFadeIn({ direction: 'up', delay });
  return (
    <div
      ref={fade.ref}
      style={fade.style}
      className="bg-white rounded-lg border-t border-gray-200 p-6 md:p-8"
    >
      <span className="font-serif text-3xl md:text-4xl block mb-4" style={{ color: 'rgba(62,95,143,0.4)' }}>
        {num}
      </span>
      <div className="mb-4">
        <div className="w-12 h-12 flex items-center justify-center">
          <i className={`${icon} text-2xl`} style={{ color: '#3E5F8F' }}></i>
        </div>
      </div>
      <h3 className="font-serif text-gray-900 text-base md:text-lg leading-relaxed mb-3">
        {title}
      </h3>
      <p className="font-light text-gray-700 text-sm leading-loose">{desc}</p>
    </div>
  );
}

export default function IconReasons() {
  const heading = useFadeIn({ direction: 'up' });

  return (
    <section className="bg-gray-50 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div ref={heading.ref} style={heading.style} className="text-center">
          <span
            className="inline-block font-medium text-xs md:text-sm tracking-[0.2em]"
            style={{ color: '#3E5F8F' }}
          >
            3 Reasons
          </span>
          <div className="w-8 h-px mt-3 mb-4 mx-auto" style={{ backgroundColor: '#3E5F8F' }}></div>
          <h2 className="font-serif text-gray-900 text-2xl md:text-3xl leading-relaxed">
            ICONが選ばれる、3つの理由
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mt-10 md:mt-12">
          {reasons.map((r, i) => (
            <ReasonCard key={r.num} {...r} delay={i * 100} />
          ))}
        </div>
      </div>
    </section>
  );
}